// src/components/AdminJobDetailModal.js
// src/components/AdminJobDetailModal.js
import React from 'react';
import './AdminJobDetailModal.css'; // Import the new CSS file

const AdminJobDetailModal = ({ job, onClose }) => {
  if (!job) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-GB');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content admin-detail-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Job Post Details</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <h3>{job.title}</h3>
          <p className="company-name">{job.jobType === 'private' ? job.companyName : 'Government Job'}</p>

          <div className="job-details-grid">
            <div className="detail-item"><strong>Posted By:</strong> <div className="detail-item-content">{job.userName} ({job.userContact})</div></div>
            <div className="detail-item"><strong>Job Role:</strong> <div className="detail-item-content">{job.jobRole || 'N/A'}</div></div>
            <div className="detail-item"><strong>Vacancies:</strong> <div className="detail-item-content">{job.vacancies}</div></div>
            <div className="detail-item"><strong>Salary:</strong> <div className="detail-item-content">{job.salary}</div></div>
            <div className="detail-item"><strong>Qualification:</strong> <div className="detail-item-content">{job.qualification || 'N/A'}</div></div>
            <div className="detail-item"><strong>Experience:</strong> <div className="detail-item-content">{job.experience || 'N/A'}</div></div>
            <div className="detail-item"><strong>Location:</strong> <div className="detail-item-content">{job.locationState}{job.locationDistrict && `, ${job.locationDistrict}`}</div></div>
            <div className="detail-item"><strong>Last Date:</strong> <div className="detail-item-content">{formatDate(job.lastDate)}</div></div>
            <div className="detail-item full-width"><strong>Eligibility:</strong> <div className="detail-item-content">{job.eligibility || 'N/A'}</div></div>
            <div className="detail-item full-width"><strong>Description:</strong> <div className="detail-item-content">{job.description || 'N/A'}</div></div>
            <div className="detail-item full-width"><strong>Apply Link:</strong> <div className="detail-item-content"><a href={job.applyLink} target="_blank" rel="noopener noreferrer">{job.applyLink}</a></div></div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="button-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default AdminJobDetailModal;